module.exports = __webpack_public_path__ + "img/pic@2x (2).d20e2231.png";